import React, { useState, useEffect } from 'react';
import { MAIN_URL } from '../../Constants';
import { Modal, Upload, Button, Image, message, Spin, Pagination } from 'antd';
import { UploadOutlined, DeleteOutlined, EyeOutlined, CheckCircleOutlined } from '@ant-design/icons';
import axios from 'axios';

const MediaManager = ({ visible, onCancel, onSelect }) => {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(12);

    // 🔥 Fayllarni olish
    const fetchFiles = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`/files`);
            if (response.data.success) {
                setFiles(response.data.data);
            }
        } catch (error) {
            message.error("Fayllarni yuklashda xatolik yuz berdi");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFiles();
    }, []);

    // 🔥 Pagination hisoblash
    const paginatedFiles = files.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    // 🔥 Upload
    const handleUpload = async (info) => {
        try {
            const formData = new FormData();
            formData.append('file', info.file);

            const response = await axios.post(`/files/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });

            if (response.data.success) {
                message.success('Fayl muvaffaqiyatli yuklandi');
                fetchFiles();
            }
        } catch (error) {
            message.error('Fayl yuklashda xatolik yuz berdi');
        }
    };

    // 🔥 Delete
    const handleDelete = async (fileName) => {
        try {
            const response = await axios.post(`/files/delete`, {
                file_name: fileName
            });

            if (response.data.success) {
                message.success('Fayl o\'chirildi');
                fetchFiles();
            }
        } catch (error) {
            message.error('Faylni o\'chirishda xatolik yuz berdi');
        }
    };

    // 🔥 Preview
    const handlePreview = (filePath) => {
        setPreviewImage(filePath);
        setPreviewVisible(true);
    };

    // 🔥 Rasm ekanligini tekshirish
    const isImageFile = (filePath) => {
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp'];
        return imageExtensions.some(ext => filePath.toLowerCase().endsWith(ext));
    };

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                
                <Upload
                    customRequest={({ file }) => handleUpload({ file })}
                    showUploadList={false}
                >
                    <Button icon={<UploadOutlined />}>Fayl yuklash</Button>
                </Upload>

                <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={files.length}
                    showSizeChanger
                    onChange={(page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                    }}
                />
            </div>

            <Spin spinning={loading}>
                <div style={{
                    marginTop: '20px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '10px'
                }}>
                    {paginatedFiles.map(file => (
                        <div
                            key={file.file_name}
                            style={{
                                position: 'relative',
                                borderRadius: '10px',
                                border: '1px solid #ccc',
                                overflow: 'hidden'
                            }}
                        >
                            {isImageFile(file.file_path) ? (
                                <Image
                                    src={MAIN_URL + '/' + file.file_path}
                                    alt={file.file_name}
                                    style={{
                                        width: '200px',
                                        height: '200px',
                                        objectFit: 'cover'
                                    }}
                                />
                            ) : (
                                <div style={{
                                    width: '200px',
                                    height: '200px',
                                    background: '#f0f0f0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    {file.file_name}
                                </div>
                            )}

                            {/* 🔥 ACTION BUTTONS */}
                            <div style={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                background: 'rgba(0,0,0,0.6)',
                                padding: '5px',
                                display: 'flex',
                                justifyContent: 'space-around'
                            }}>
                                <Button
                                    icon={<EyeOutlined />}
                                    onClick={() => handlePreview(file.file_path)}
                                />

                                <Button
                                    danger
                                    icon={<DeleteOutlined />}
                                    onClick={() => handleDelete(file.file_name)}
                                />

                                <Button
                                    type="primary"
                                    icon={<CheckCircleOutlined />}
                                    onClick={() => onSelect(file.file_path)}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </Spin>

            {/* 🔥 PREVIEW MODAL */}
            <Modal
                open={previewVisible}
                footer={null}
                onCancel={() => setPreviewVisible(false)}
            >
                <img
                    alt="preview"
                    style={{ width: '100%', borderRadius: '10px' }}
                    src={MAIN_URL + '/' + previewImage}
                />
            </Modal>
        </>
    );
};

export default MediaManager;